module.exports = __webpack_public_path__ + "static/media/logo.a957fec2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 412
// module chunks = 0